import React from "react";
import { Goal } from "@/types/goals";
import BeneficiaryGoal from "./BeneficiaryGoal";

interface GoalListProps {
  goals: Goal[];
  isUserEnrolled?: boolean;
  onGoalChange: (
    goalId: string | number,
    field: string,
    value: string | number | boolean,
  ) => void;
}

const GoalList: React.FC<GoalListProps> = ({
  goals,
  isUserEnrolled,
  onGoalChange,
}) => {
  return (
    <div
      className={`${
        !isUserEnrolled &&
        "text-[18px] shadow-introBox font-outfit bg-white w-full rounded-[16px]"
      }`}
    >
      {goals?.map((beneficiary, index) => (
        <BeneficiaryGoal
          key={`${beneficiary.beneficiaryId}-${index}`}
          beneficiary={beneficiary}
          onChange={onGoalChange}
          isLast={index === goals.length - 1}
          isUserEnrolled={isUserEnrolled}
        />
      ))}
    </div>
  );
};

export default GoalList;
